import { LogOut, Calendar, FileText, TrendingUp } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { LOGO } from "@/components/site/assets";

const ROLE_LABELS = {
  athlete: "Athlete",
  parent: "Parent / Guardian",
  coach: "Coach",
  org: "Organization",
};

export default function WelcomePortal() {
  const { user, logout } = useAuth();
  const roleLabel = ROLE_LABELS[user?.role] || "Member";

  const CARDS = [
    { icon: Calendar, title: "Your Sessions", body: "Upcoming training sessions and evaluations will appear here." },
    { icon: TrendingUp, title: "Progress", body: "Test scores, baselines, and progress graphs are coming soon." },
    { icon: FileText, title: "Documents", body: "Waivers, reports, and your digital athlete binder will live here." },
  ];

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white" data-testid="welcome-portal">
      <header className="border-b border-white/10 bg-black">
        <div className="max-w-5xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src={LOGO} alt="JJ Speed Factory" className="h-10 w-auto object-contain" />
            <span className="font-mono-accent text-[10px] tracking-[0.25em] uppercase text-white/40 border-l border-white/20 pl-3">
              {roleLabel} Portal
            </span>
          </div>
          <button
            data-testid="portal-logout"
            onClick={logout}
            className="inline-flex items-center gap-2 border border-white/20 px-4 py-2 text-xs uppercase tracking-widest font-bold hover:bg-white hover:text-black transition-colors"
          >
            <LogOut size={14} /> Log Out
          </button>
        </div>
      </header>

      <main className="max-w-5xl mx-auto px-6 md:px-12 py-16">
        <p className="font-mono-accent text-xs tracking-[0.3em] uppercase text-white/40 mb-4">
          Welcome
        </p>
        <h1 className="font-display font-black uppercase tracking-tighter text-4xl md:text-6xl mb-6" data-testid="portal-name">
          {user?.name || "Athlete"}
        </h1>
        <p className="text-white/60 max-w-xl text-lg leading-relaxed mb-14">
          Your account is active. Coach Johnson will schedule your first session and
          your training tools will unlock here as your program gets underway.
        </p>

        <div className="grid sm:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {CARDS.map((c) => {
            const Icon = c.icon;
            return (
              <div key={c.title} className="bg-[#0A0A0A] p-7" data-testid={`portal-card-${c.title.toLowerCase().replace(/\s/g, "-")}`}>
                <Icon size={22} className="text-white/70 mb-4" />
                <h3 className="font-display font-bold uppercase tracking-tight text-lg mb-2">{c.title}</h3>
                <p className="text-white/45 text-sm leading-relaxed">{c.body}</p>
              </div>
            );
          })}
        </div>

        <p className="text-white/30 text-xs mt-10">
          Questions? Reach Coach Johnson at coachjohnsonrecruiting9@gmail.com.
        </p>
      </main>
    </div>
  );
}
